import { ReactNode } from "react"
import { NuqsAdapter } from "nuqs/adapters/react"

import { ShortcutsProvider } from "./ui/primitives/key-board-shortcuts"

export function Providers({ children }: { children: ReactNode }) {
  return (
    <NuqsAdapter>
      <ShortcutsProvider os="mac">{children}</ShortcutsProvider>
    </NuqsAdapter>
  )
}
